import * as React from "react";
import ResourcesTab from "./ResourcesTab";
import { staticURLs } from "../../config/urls";
import LogoContainer from "../common/LogoContainer";
import * as ConfigurationActions from "../../store/configurationService/actions";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import { useTranslation } from "react-i18next";
import { useResourceTabPermission } from "../../util/CommonServices";

const BreachReadiness = () => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const productFeatureOfBIDR = useSelector((state: ApplicationState) => state.productFeatureState?.productFeatureData);
    const displayCyberRiskProfile = useResourceTabPermission(productFeatureOfBIDR?.AllowWhiteHawkAssessment);
    let preferencedLanguageBool;
    React.useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        {tLang("resourcesSection.resourcesTitleText")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ResourcesTab selectedTab="3" />

            <div className="row" id="content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="shield-alt" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("resourcesSection.breachReadinessSupportWidget.title")}</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>{tLang("resourcesSection.breachReadinessSupportWidget.descriptionMessage1")}</p>
                                <br />
                                <p>{tLang("resourcesSection.breachReadinessSupportWidget.descriptionMessage2")}</p>
                            </div>
                        </div>

                        <div className="box-content">
                            <div className="resource-container">
                                <a
                                    href={preferencedLanguage === "fr" ? "doc\\Information Security Breach Response Plan_fr1.pdf" : "doc\\Information Security Breach Response Plan.pdf" }
                                    onClick={() => window.addToDataLayer({ event: "Information Security Breach" })}
                                    target="_blank"
                                    className="resource-link"
                                    rel="noreferrer"
                                >
                                    <span className="resource-icon">
                                        <em className="lar la-file-pdf"></em>
                                    </span>
                                    <span className="resource-text">
                                        {/*<span className="resource-title">{tLang("resourcesSection.breachReadinessSupportWidget.breachPlanPDF")}</span>*/}
                                        <span className="resource-title">{tLang("resourcesSection.breachReadinessSupportWidget.informationSecurityBreach")}</span>
                                        <span className="resource-description">(PDF)</span>
                                    </span>
                                </a>
                            </div>

                            {displayCyberRiskProfile && preferencedLanguage === "en" && (
                                <div className="resource-container">
                                    <a
                                        href={staticURLs.smallBusinessResBreach}
                                        onClick={() => window.addToDataLayer({ event: "Additional Security Resources" })}
                                        target="_blank"
                                        className="resource-link"
                                        rel="noreferrer"
                                    >
                                        <span className="resource-icon">
                                            <em className="las la-link"></em>
                                        </span>
                                        <span className="resource-text">
                                            <span className="resource-title">Additional Security Resources</span>
                                        </span>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default BreachReadiness;
